import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Hero, HeroVariant } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { Services } from './components/Services';
import { Reviews } from './components/Reviews';
import { QuotePath } from './components/QuotePath';
import { Locations } from './components/Locations';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
const TITLE = 'Kosin’s Glass | Auto, Home, Shower & Commercial Glass';
const DESCRIPTION = 'Kosin’s Glass is a family-owned glass company serving Southeast Michigan since 2000: auto glass and windshields, residential window glass, custom glass shower doors and commercial glazing. Howell showroom, 517-545-7772.';
function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
function readHeroVariant(): HeroVariant {
  if (typeof window === 'undefined') return 'van';
  const value = new URLSearchParams(window.location.search).get('hero');
  return value === 'storefront' ? 'storefront' : 'van';
}
export function App() {
  const [heroVariant, setHeroVariant] = useState<HeroVariant>(readHeroVariant);
  useEffect(() => {
    document.title = TITLE;
    setMeta('description', DESCRIPTION);
    setMeta('robots', 'noindex,nofollow');
  }, []);
  useEffect(() => {
    const syncVariant = () => setHeroVariant(readHeroVariant());
    window.addEventListener('popstate', syncVariant);
    return () => window.removeEventListener('popstate', syncVariant);
  }, []);
  return <div id="top" className="w-full bg-white" data-id="element-0" data-mp="nuhh6fb985sp">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded focus:bg-kosin-charcoal focus:px-4 focus:py-2 focus:text-white" data-id="element-1" data-mp="nxwwnj8ubgun">
        Skip to main content
      </a>
      <Header data-id="element-2" data-mp="3ubzumd3utnfp" />
      <main id="main-content" tabIndex={-1} data-id="element-3" data-mp="3ucjbrrlok7so">
        <Hero variant={heroVariant} data-id="element-4" data-mp="d4e94339pv1g" />
        <TrustStrip data-id="element-5" data-mp="d3cwvvain2i5" />
        <Services data-id="element-6" data-mp="d2l9v8uzid3h" />
        <Reviews data-id="element-7" data-mp="85l3sxy4xacd" />
        <QuotePath data-id="element-8" data-mp="851kpdwr0fwr" />
        <Locations data-id="element-9" data-mp="86mev2f5hwu3" />
        <Faq data-id="element-10" data-mp="8648ve2os48z" />
        <FinalCta data-id="element-11" data-mp="83i3nl39q0tx" />
      </main>
      <Footer data-id="element-12" data-mp="3gl4r7gc4jyji" />
    </div>;
}